/* SANTO storefront fixes (ported from SimplyActive sa-meet-fixes.js) */
(function () {
  // Open the product page on the photo of the colour the shopper picked
  var synced = false;
  function syncGallery() {
    if (synced) return;
    var gallery = document.querySelector('media-gallery');
    var id = new URLSearchParams(location.search).get('variant');
    if (!gallery || !id || typeof gallery.setActiveMedia !== 'function') return;
    synced = true;
    fetch(location.pathname.replace(/\/$/, '') + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === id) v = p.variants[i];
        if (!v || !v.featured_media) return;
        var section = gallery.id.replace('MediaGallery-', '');
        if (!gallery.querySelector('[data-media-id="' + section + '-' + v.featured_media.id + '"]')) return;
        gallery.setActiveMedia(section + '-' + v.featured_media.id, true);
        setTimeout(kickStalledImages, 50);
      })
      .catch(function () {});
  }

  // Images moved after the browser's lazy pass never load; force them
  function kickStalledImages() {
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) continue;
      var box = img.getBoundingClientRect();
      if (box.width === 0 && box.height === 0) continue;
      if (box.bottom < -300 || box.top > window.innerHeight + 600) continue;
      var src = img.getAttribute('src'); if (!src) continue;
      var srcset = img.getAttribute('srcset');
      img.setAttribute('loading', 'eager');
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
    }
  }

  // Give icon-only buttons a name for screen readers
  function label() {
    var btns = document.querySelectorAll('button:not([aria-label]), a.link:not([aria-label])');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.innerText.trim()) continue;
      var c = (b.className || '') + ' ' + (b.name || '') + ' ' + (b.id || '');
      var name =
        /wish/i.test(c) ? 'Add to wishlist' :
        /close|dismiss/i.test(c) ? 'Close' :
        /prev/i.test(c) ? 'Previous' :
        /next/i.test(c) ? 'Next' :
        /checkout/i.test(c) ? 'Check out' :
        /discount/i.test(c) ? 'Apply discount' :
        /product-form__submit|atc/i.test(c) ? 'Add to cart' :
        /cart/i.test(c) ? 'Cart' :
        /search/i.test(c) ? 'Search' :
        /menu|drawer/i.test(c) ? 'Menu' :
        /plus|increase/i.test(c) ? 'Increase quantity' :
        /minus|decrease/i.test(c) ? 'Decrease quantity' : null;
      if (name) b.setAttribute('aria-label', name);
    }
  }

  function run() { syncGallery(); kickStalledImages(); label(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function(){ kickStalledImages(); label(); }, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
